import { render, staticRenderFns } from "./MainTableSix.vue?vue&type=template&id=2cd4ae78&scoped=true&"
import script from "./MainTableSix.vue?vue&type=script&lang=js&"
export * from "./MainTableSix.vue?vue&type=script&lang=js&"
import style0 from "./MainTableSix.vue?vue&type=style&index=0&id=2cd4ae78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd4ae78",
  null
  
)

export default component.exports